import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgExerciseGlyphSecondary from './svgs/ExerciseGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var exerciseGlyph = (props => useIcon(null, SvgExerciseGlyphSecondary, props));

export { exerciseGlyph as default };
